import { render, staticRenderFns } from "./ForgotFinalForm.vue?vue&type=template&id=53657648"
import script from "./ForgotFinalForm.vue?vue&type=script&lang=js"
export * from "./ForgotFinalForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotFinalForm.vue?vue&type=style&index=0&id=53657648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
